import React, { Fragment, Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Route, Redirect } from 'react-router-dom';
import Header from '../components/parts/Header';
import AppDrawer from '../components/parts/Drawer';
import { Auth } from '../auth/Auth';
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		padding: '0 8px',
		...theme.mixins.toolbar
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		marginTop: theme.spacing(2)
    },
    display : {
        display :'none'
    }
}));





const OpenRoutes = ({ component: Component, path, ...rest }) => {
	const classes = useStyles();
	const [ open, setOpen ] = React.useState(false);
	const openDrawer = React.useCallback(() => setOpen(false));
	const closeDrawer = React.useCallback(() => setOpen(false));
	return (
		<Fragment>
			<Header open={open} openDrawer={openDrawer} drawerWidth={drawerWidth} />
			<AppDrawer open={open} closeDrawer={closeDrawer} drawerWidth={drawerWidth} style={{display:'none'}} />
			<main className={classes.content}>
				<div className={classes.toolbar} />
				<Route
					{...rest}
					render={({ match }) =>
						<Component match={match} />
						}
				/>
			</main>
		</Fragment>
	);
};

export default OpenRoutes;
